import _ from 'lodash';
import CONSTANTS from '../constants';

export default {
  getItems,
  getPopularItems,
  getItem,
  getCategoryItem
};

async function getItems(menuBlob, loc_id) {
  let jsonCategories = reducer(JSON.parse(menuBlob).menu_data) || [];
  let items = _.flatten(jsonCategories.map((jsonCategory) => jsonCategory.Menu));
  items.forEach((item) => {
    item.loc_id = loc_id;
    if (item.menu_photo.includes('dishPlaceholderImg')) item.menu_photo = null;
  });
  if (items) return items;

  throw new Error('Items not found');
}

async function getCategoryItem(menuBlob, loc_id) {
  let jsonCategories = reducer(JSON.parse(menuBlob).menu_data) || [];
  let items = _.flatten(jsonCategories.map((jsonCategory) => jsonCategory.Menu));
  let category = _.flatten(jsonCategories.map((jsonCategory) => jsonCategory.Category));
  items.forEach((item) => {
    let cat = category.find((p) => p.category_id === item.menu_category_id);
    item.loc_id = loc_id;
    item.category_name = cat.name;
    if (item.menu_photo.includes('dishPlaceholderImg')) item.menu_photo = null;
  });
  category.forEach((cat) => {
    cat.menu = items.filter((p) => p.menu_category_id === cat.category_id);
  });
  if (category) return category;

  throw new Error('Items not found');
}

function reducer(data) {
  const menuData = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < menuData.length; i++) {
    const { Menu: menu } = menuData[i];
    for (let j = 0; j < menu.length; j++) {
      const { MenuOptions: menuOptions } = menu[j];
      for (let k = 0; k < menuOptions.length; k++) {
        menuOptions[k] = { ...menuOptions[k], ...menuOptions[k].Option };

        const optionValuesMap = new Map();
        menuOptions[k].OptionValues.forEach((ov) => {
          optionValuesMap.set(ov.option_value_id, ov);
        });

        const newMenuOptionValues = menuOptions[k].MenuOptionValues.map((mov) => {
          const optionValue = optionValuesMap.get(mov.option_value_id) || {};
          return {
            ...optionValue,
            ...mov,
            price: mov.new_price ?? optionValue.price ?? ''
          };
        });

        menuOptions[k].OptionValues = newMenuOptionValues;
      }
    }
  }
  return menuData;
}

async function getPopularItems(locationId) {
  // let items = await fetch(`${CONSTANTS.API_URL}${CONSTANTS.URLS.ITEMS.POPULAR_ITEMS}`, {
  //   method: 'POST',
  //   body: JSON.stringify({ location_id: locationId, limit: 10 })
  // });
  let items = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.LOCATIONS.TOP_RATED(locationId, 10)}`
  );
  items = await items.json();
  if (items) return items;

  throw new Error('Could not get popular items');
}

async function getItem(itemId) {
  let item = await fetch(`${CONSTANTS.API_URL}${CONSTANTS.URLS.ITEMS.ITEM.GET}`, {
    method: 'POST',
    body: JSON.stringify({ menu_id: itemId })
  });
  item = await item.json();
  if (item) return item;

  throw new Error('Items not found');
}
